import * as React from "react";

import Image from "@client/controls/Image/component";

export type ImageGalleryImagePreviewComponentProps = {
  imageSrc: string | null;
  onLoaded: () => void;
};
export default (props: ImageGalleryImagePreviewComponentProps) => (
  <div className="preview_image">
    {!!props.imageSrc && <Image src={props.imageSrc} onImageLoaded={props.onLoaded} />}
  </div>
);
